module.exports = __webpack_public_path__ + "static/media/Reporting15.7e92e36b.png";